<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><div class="chapter"><a id="page_1"></a><a id="p9000f15f9970001001"> </a><p class="halftitle">The Beader’s Bible</p></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?59853020